import { render, staticRenderFns } from "./ActivityDetailScreen.vue?vue&type=template&id=09d7e145&scoped=true&"
import script from "./ActivityDetailScreen.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailScreen.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetailScreen.vue?vue&type=style&index=0&id=09d7e145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7e145",
  null
  
)

export default component.exports